import { Component, OnInit, Input } from '@angular/core';
import {
  trigger,
  state,
  style,
  animate,
  transition
} from '@angular/animations'
import { NavService } from '../../services/nav.service'

@Component({
  selector: 'app-intro',
  templateUrl: './intro.component.html',
  styleUrls: ['./intro.component.scss'],
  animations: [
    trigger('fadeIn', [
      state('in', 
        style({ 
          opacity: 1,
          marginTop: '0'
        })
      ),
      state('out', 
        style({ 
          opacity: 0,
          marginTop: 30
        })
      ),
      transition('out => in', animate('0.8s cubic-bezier(.17,.67,.83,.67)')),
      transition('in => out', animate('0.8s cubic-bezier(.17,.67,.83,.67)'))
    ])
  ]
})
export class IntroComponent implements OnInit {
  public fadeIn = false

  @Input() copy: string
  @Input() _editable: any
  constructor(
    private nav: NavService
  ) { }

  ngOnInit() {
    if(this.copy) {
      setTimeout(() => {
        this.fadeIn = true

        console.log('fade in now.');
      }, 600)
    }
  }

  // changeActiveNav(id) {
  //   this.nav.changeActiveNavItem(id, 'page component')
  // } 

  public onIntersection({ target, visible }, id): void {
    if(visible) {
      this.nav.changeActiveNavItem(id)
    }
  }
}
